/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Posts_DeleteInputs */

const he_posts_delete = /** @type {(inputs: Posts_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחק פוסט`)
};

const en_posts_delete = /** @type {(inputs: Posts_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Post`)
};

/**
* | output |
* | --- |
* | "Delete Post" |
*
* @param {Posts_DeleteInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const posts_delete = /** @type {((inputs?: Posts_DeleteInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Posts_DeleteInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_posts_delete(inputs)
	return en_posts_delete(inputs)
});